(() => {
  'use strict';

  const loadSetImages = (menu) => {
    menu.querySelectorAll('img[data-vmax-set-src]').forEach((image) => {
      image.src = image.dataset.vmaxSetSrc;
      image.removeAttribute('data-vmax-set-src');
    });
  };

  const initializeSetMenus = () => {
    document.querySelectorAll('.vmax-set-menu').forEach((menu) => {
      if (menu.dataset.vmaxSetMenuInitialized === 'true') return;

      menu.dataset.vmaxSetMenuInitialized = 'true';
      const wrapper = menu.closest('[data-sub-menu-category-id]');
      const categoryId = wrapper && wrapper.dataset.subMenuCategoryId;
      const trigger = categoryId
        ? document.querySelector(`[data-top-menu-category-id="${categoryId}"]`)
        : null;
      const load = () => loadSetImages(menu);

      if (trigger) {
        trigger.addEventListener('pointerenter', load, { once: true });
        trigger.addEventListener('focus', load, { once: true });
        trigger.addEventListener('touchstart', load, { once: true, passive: true });
      }

      menu.addEventListener('focusin', load, { once: true });
    });
  };

  if (window.vmaxSetMenuRuntime && typeof window.vmaxSetMenuRuntime.initialize === 'function') {
    window.vmaxSetMenuRuntime.initialize();
    return;
  }

  window.vmaxSetMenuRuntime = Object.freeze({ initialize: initializeSetMenus });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSetMenus, { once: true });
  } else {
    initializeSetMenus();
  }

  document.addEventListener('shopify:section:load', initializeSetMenus);
})();
